/*----------------------------------
- DEPENDANCES
----------------------------------*/

// Npm
import React from 'react';
import { MantineProvider } from '@mantine/core';

// Core
import type { TClientOrServerContextForPage } from '@common/router';

// Local override
import CoreApp from '../../node_modules/proteum/client/app/component';
import { ToastProvider } from '@/client/components/ui/Toast';

/*----------------------------------
- COMPOSANT
----------------------------------*/
export default function App({ context }: { context: TClientOrServerContextForPage }) {
    const content = (
        <ToastProvider>
            <CoreApp context={context} />
        </ToastProvider>
    );

    if (!context.request.path.startsWith('/old/')) return content;

    // Keep the provider in the same module graph as legacy Mantine components during SSR.
    return <MantineProvider>{content}</MantineProvider>;
}
